<template lang="pug">
  .component-plan-configuration
    .content
      .column.row
        ActionBar
          h2(slot="title") Rate configuration

        .tabs-inner-content
          label Inherited reservation rate
            select(v-model="body.inherited_reservation_rate_id")
              option(:value="null") Not inherited
              option(v-for="rate in available", :value="rate.id") {{rate.name}}
          label Name
            input(type="text", v-model="body.name")
          textarea(rows="25", v-model="body.config")

          ActionButton(:action="save") Save

</template>
<script type="text/babel">

import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import {mapState} from 'vuex'
import ActionButton from '../../structure/ui/ActionButton'
import ActionBar from '../../structure/ui/ActionBar'
import MaggieHelper from "../../../maggieHelper";

export default {
  name: 'RateConfiguration',
  components: {
    ActionBar,
    ActionButton,
  },
  data() {
    return {
      body: {inherited_reservation_rate_id: null, config: {}, name: null},
      available: []
    }
  },
  created() {
    KeplerBackofficeSdk.reservationRates.list.rates((data) => {
      this.available = data
    })

    this.body.config = JSON.stringify({}, null, 2)

    if (this.$route.params.id) {
      KeplerBackofficeSdk.reservationRates.select(this.$route.params.id).get((data) => {
        this.body.config = JSON.stringify(data.config, null, 2)
        this.body.name = data.name
        this.body.inherited_reservation_rate_id = data.inherited_reservation_rate_id
      })
    }
  },
  methods: {
    save() {
      const body = {...this.body}
      body.config = JSON.parse(this.body.config)
      if (this.$route.params.id) {
        return KeplerBackofficeSdk.reservationRates.select(this.$route.params.id).edit(body, (data) => {
          MaggieHelper.notification('rate', 'Base rate updated')
          this.$router.push({name: 'rates'})

        })
      }

      return KeplerBackofficeSdk.reservationRates.make(body, (data) => {
        MaggieHelper.notification('rate', 'Base rate saved')
        this.$router.push({name: 'rates'})
      })
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),

  },
  props: ['item']
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-plan-configuration

  textarea
    font-family: monospace

  h3
    color: #5EB9CF
    padding: 0
    margin: 0

  .input-group-label
    border: none
    background-color: transparent

  small.description-text
    display: block
    opacity: .75
    line-height: 1
    margin-bottom: 1em
    text-transform: none

  .acronym
    font-size: .8em
    margin-left: .5em
    opacity: .8

  button.fullwidth
    width: 100%

  .rate-preview
    .card
      background-color: rgba(202, 202, 202, 0.2)
      padding: 1em

    .d-block
      display: block

    .small-2
      margin-right: 1em

    .input-group-label
      p
        margin: 0 auto

</style>



// WEBPACK FOOTER //
// RateConfiguration.vue?41487233